const modal = {
	styleOverrides: {
		backdrop: ({ theme }) => ({
			backgroundColor: `${theme.palette.black[500]}E6`,
		}),
	},
};

export default modal;
